import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/user'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
// .catch(e => {
//     console.log(e);
//     // throw (e)
// });


export default class UserApi {

    static async addUser({ data = { login: undefined, password: undefined, name: undefined, role: undefined }, ...params }) {
        return await fetchService({ url: '/adduser', method: 'POST', data, ...params })
    }

    static async getAllUsers({ data = undefined, ...params }) {
        return await fetchService({ url: '/getusers', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async getUsersByRole({ data = { role: undefined, }, ...params }) {
        return await fetchService({ url: '/getusersbyrole', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async changeUser({ data = { login: undefined, data: undefined }, ...params }) {
        return await fetchService({ url: '/changeuser', method: 'POST', data, ...params })
    }

    static async changePassword({ data = { login: undefined, password: undefined }, ...params }) {
        return await fetchService({ url: '/changepassword', method: 'POST', data, ...params })
    }

    static async removeUser({ data = { login: undefined }, ...params }) {
        return await fetchService({ url: '/removeuser', method: 'DELETE', data, ...params })
    }



    static async getUsersAvatar({ data = undefined, ...params }) {
        return await fetchService({ url: '/getusersavatars', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async getAuthBarcode({ data = { login: undefined }, ...params }) {
        return await fetchService({ url: '/getqr', method: 'POST', data, ...params })
    }

    static async setScannerId({ data = { login: undefined, scanerId: undefined }, ...params }) {
        return await fetchService({ ...params, url: '/setscannerid', method: 'POST', data, notify: { success: false, ...params.notify }, })
            .then(() => { 
                showSuccessNotify(`Сканер id:${data.scanerId} успешно привязан`); 
            })
    }



    static async login({ data = { login: undefined, password: undefined }, ...params }) {
        return await fetchService({ url: '/login', method: 'POST', data, ...params })
    }

    static async logout({ data = undefined, ...params }) {
        return await fetchService({ url: '/logout', method: 'POST', data, ...params })
    }

    static async checkSession({ data = undefined, ...params }) {
        return await fetchService({ url: '/session', method: 'GET', data, notify: { success: false }, ...params })
    }

     static async getVersion({ data = undefined, ...params }) {
        return await fetchService({ url: '/version', method: 'GET', data, notify: { success: false }, ...params })
    }



    


    static async getUserFinances({ data = { userId: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/getuserfinances', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getFinancesByPeriod({ data = { financeId: undefined, endDate: undefined }, ...params }) {
        return await fetchService({ url: '/getfinancesperiod', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeFinancesPeriod({ data = { financeId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changefinancesperiod', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getUserPenalties({ data = { userId: undefined, period: undefined, filter: undefined, search: undefined, tab: undefined, page: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getuserpenalties', method: 'POST', data, notify: { success: false }, ...params })
    }



    static async addExtraWork({ data = { userId: undefined, extraWork: undefined }, ...params }) {
        return await fetchService({ url: '/addextrawork', method: 'POST', data, ...params })
    }

    static async addRetention({ data = { userId: undefined, sum: undefined, comment: undefined, reason: undefined, date: undefined }, ...params }) {
        return await fetchService({ url: '/addretention', method: 'POST', data, ...params })
    }

    static async changePenalty({ data = { penaltyId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changepenalty', method: 'POST', data, ...params })
    }

}